module.exports = __webpack_public_path__ + "static/students-008a0ab3dd3ee86080c878fe74bf4c8a.jpg";